/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'bot-detection-policy';
const componentName = 'ip-reputation-type-mapping';
const prefix = `${moduleName}.${componentName}`;

export const typeMappingTitle = `${prefix}.typeMappingTitle`;
export const allowRuleTitle = `${prefix}.allowRuleTitle`;

export const ENGLISH = {
    [typeMappingTitle]: 'Type Mapping',
    [allowRuleTitle]: 'Allow Rule',
};
